"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Link_1 = require("../../atoms/Link");
/**
 * See `<Footnote>` component for example usage.
 * @visibleName Footnote.Anchor
 */


var Anchor =
/** @class */
function (_super) {
  __extends(Anchor, _super);

  function Anchor() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      identifier: _this.props.identifier || "?"
    };

    _this.updateIdentifier = function () {
      var footnoteElement = document.getElementById(_this.props.idItem);
      var identifierElement = footnoteElement && footnoteElement.querySelector("." + CSSPrefix_1.lsgPre + "footnote-item-identifier");
      var identifier = identifierElement && identifierElement.innerHTML;

      if (identifier) {
        _this.setState({
          identifier: identifier
        });
      }
    };

    return _this;
  }

  Anchor.prototype.componentDidMount = function () {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(this.updateIdentifier);
    } else {
      setTimeout(this.updateIdentifier, 300);
    }
  };

  Anchor.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        idItem = _a.idItem,
        identifier = _a.identifier;
    return React.createElement(Link_1.Link, {
      href: "#" + idItem
    }, children, React.createElement("sup", null, identifier || this.state.identifier));
  };

  return Anchor;
}(React.Component);

exports.Anchor = Anchor;